module.exports = __webpack_public_path__ + "img/Lleida.4bcf698b.png";